import _default from './Table';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/collections/Table/index.js
// module id = 3288
// module chunks = 0